import templateUrl from './timeline-questions-list.html';

export const timelineQuestionsComponent = {
    bindings : {
        details : '<'
    },
    templateUrl,
    controller: class TimelineQuestionsListComponent {

        constructor(DateService, $stateParams,surveyService, toastr, AuthService, $state){
            'ngInject';

            this.dateService = DateService;
            this.$state = $state;
			this.$stateParams = $stateParams;
			this.pushNotificationService = surveyService;
			this._toastr = toastr;
			this.authService = AuthService;
        }

        $onInit(){
			this.isEmpty = this.details.count === 0 ? true : false;
			this.currentPage = 1;
            this.itemPerPage = 10;
            this.totalItems = this.details.count;
            
        }
        onChangePage(pageNumber) {
			this.currentPage = pageNumber;
			this._getNotificationDetailsByFilter();
        }
        _getNotificationDetailsByFilter() {
			const filtersObject = {
				sortBy: this.sortBy,
				limit: this.itemPerPage,
				pageId: this.currentPage,
				selectedStatusList: this.selectedStatusList,
				notificationFor: this.notificationUserList,
				startDuration: this.startDuration,
				endDuration: this.endDuration
			}
			
			this.pushNotificationService.getNotificationList(filtersObject).then(({ pushNotificationListObject = [], count }) => {
				this.details.pushNotificationListObject = angular.copy(pushNotificationListObject);
				if(count || count === 0) {
					this.totalItems = count;
				}
				this.isEmpty = this.details.pushNotificationListObject.length === 0 ? true: false;
				this.isFiltered = true;
			});

        }
        
        onGoBack(){
            this.$state.go('surveyUserList', {
                id:this.$stateParams.id
            });
        }
       

    }
}


// WEBPACK FOOTER //
// ./src/app/components/timeline/timeline-questions/timeline-questions.component.js